import { Component } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
})
export class NavComponent {
  hideElement = false;
  showElement = false;

  constructor(private route: ActivatedRoute, public router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.hideElement = false;
        } else {
          this.hideElement = true;
        }

        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.showElement = true;
        } else {
          this.showElement = false;
        }
      }
    });
  }

  onMobileMenuClick() {
    const element = document.querySelector("#navbar");
    if (element.classList.contains("in")) {
      element.classList.remove("in");
    }
  }

  onAnchorClick() {
    this.route.fragment.subscribe((f) => {
      const element = document.querySelector("#" + f);
      if (element) {
        element.scrollIntoView();
      }
      this.onMobileMenuClick();
    });
  }

  ngOnInit() {
    this.router.events.subscribe((s) => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element) {
            element.scrollIntoView();
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/nav/nav.component.ts